import React from "react";
import PropTypes from "prop-types";
import { humanEUR } from "./format";

// MoMChip shows projected month-end vs the previous full-month actual. The colour
// stays neutral grey on purpose — the arrow conveys direction, not alarm.
const MoMChip = ({ momPct, prevActual, prevLabel }) => {
  if (!(Number(prevActual) > 0) || !prevLabel) return null;
  const p = Math.round((Number(momPct) || 0) * 100);
  const arrow = p > 0 ? "▲" : p < 0 ? "▼" : "→";
  return (
    <span className="text-xs font-medium text-text-2">
      {arrow} {Math.abs(p)}% vs {prevLabel} ({humanEUR(prevActual)})
    </span>
  );
};

MoMChip.propTypes = {
  momPct: PropTypes.number,
  prevActual: PropTypes.number,
  prevLabel: PropTypes.string,
};

export default MoMChip;
